var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.player.show,
          expression: "player.show"
        }
      ],
      staticClass: "bootbox modal video-player-modal",
      style: { zIndex: _vm.zIndex },
      attrs: { transition: "fade" }
    },
    [
      _c("div", { staticClass: "modal-backdrop in" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "button",
              {
                staticClass: "bootbox-close-button close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.player.show = false
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-close" })]
            ),
            _vm._v(" "),
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.player.title))
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c(
        "video",
        {
          staticClass: "video-js vjs-default-skin vjs-big-play-centered",
          attrs: { "data-role": "video-player", controls: "", preload: "auto" }
        },
        [
          _c("p", { staticClass: "vjs-no-js" }, [
            _vm._v(
              "To view this video please enable JavaScript, and consider upgrading to a web browser that "
            ),
            _c("a", { attrs: { href: "#", target: "_blank" } }, [
              _vm._v("supports HTML5 video")
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }